import React, {useEffect, useRef, useState} from 'react';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from 'primereact/button';
import {Dialog} from 'primereact/dialog';
import {InputText} from 'primereact/inputtext';
import {InputNumber} from 'primereact/inputnumber';
import {Checkbox} from 'primereact/checkbox';
import {InputTextarea} from 'primereact/inputtextarea';
import {Toolbar} from 'primereact/toolbar';
import {Toast} from 'primereact/toast';
import {Card} from 'primereact/card';
import {Divider} from 'primereact/divider';
import {TabPanel, TabView} from 'primereact/tabview';
import './DestinationCatalog.scss';
import {IconField} from "primereact/iconfield";
import {InputIcon} from "primereact/inputicon";
import {addDestination, disableDestination, getDestinations, updateDestination} from "./DestinationCatalog.service";
import {Dropdown} from "primereact/dropdown";
import { Tooltip } from 'primereact/tooltip';
import Map, {DestinationMarker } from "../../../components/molecules/Map/Map"
import MapFlyToProveedor from "../../../components/molecules/Map/MapFly";
import {ConfirmDialog, confirmDialog} from "primereact/confirmdialog";
import Swal from "sweetalert2";
import INEGIGeocoderInput from "../../../components/molecules/Map/GeocoderControl";

const DestinationCatalog = () => {
    const DEFAULT_CENTER = [20.67129241646564, -103.35232101509537];
    const markerRef = useRef(null);
    const [destinations, setDestinations] = useState([]);
    const [states, setStates] = useState([]);
    const [selectedState, setSelectedState] = useState([]);

    const [destinationDialog, setDestinationDialog] = useState(false);
    const [deleteDestinationDialog, setDeleteDestinationDialog] = useState(false);
    const [destination, setDestination] = useState({});
    const [selectedDestinations, setSelectedDestinations] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const toast = useRef(null);
    const dt = useRef(null);

    useEffect(() => {
        getDestinations().then((data) => {
            setDestinations(data.destinations);
            setStates(data.states);
        })
    }, []);

    const openNew = () => {
        setDestination({
            ciudad: '',
            estado: '',
            frecuente: false,
            kilometros: 0,
            casetas2: 0,
            casetas3: 0,
            horas: '',
            duracion: 0,
            activa: true,
            foraneo: false,
            autobus: 0,
            camion: 0,
            sprinter: 0,
            van: 0,
            latitud: 0,
            longitud: 0,
            nota: ''
        });
        setSubmitted(false);
        setDestinationDialog(true);
    };

    const hideDialog = () => {
        setSubmitted(false);
        setDestinationDialog(false);
    };

    const hideDeleteDestinationDialog = () => {
        setDeleteDestinationDialog(false);
    };

    const saveDestination = async () => {
        setSubmitted(true);

        const isValid =
            destination.ciudad?.trim() &&
            destination.idEstado &&
            destination.kilometros &&
            destination.latitud &&
            destination.longitud;

        if (!isValid) {
            return;
        }


        if (destination.ciudad.trim()) {
            let _destinations = [...destinations];
            let _destination = { ...destination };

            if (destination.id) {
                // @TODO actualizar el destino
                const index = findIndexById(destination.id);
                _destinations[index] = _destination;
                console.log('actualizar', _destination);
                await updateDestination(_destination);
                Swal.fire('Exitoso', 'Destino Actualizado', 'success');
            } else {
                // @TODO crear el destino

                _destination.id = await addDestination(_destination);
                console.log('agregar', _destination);
                _destinations.push(_destination);
                Swal.fire('Exitoso', 'Destino Creado', 'success');
            }

            setDestinations(_destinations);
            setDestinationDialog(false);
            setDestination({});
        }
    };

    const editDestination = (destination) => {
        setDestination({ ...destination });
        setDestinationDialog(true);
    };

    const findIndexById = (id) => {
        let index = -1;
        for (let i = 0; i < destinations.length; i++) {
            if (destinations[i].id === id) {
                index = i;
                break;
            }
        }
        return index;
    };

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _destination = { ...destination };

        if (name === 'idEstado') {
            _destination.idEstado = val.code;
            _destination.estado = val.name;
        } else {
            const finalValue = val.code ?? val;
            _destination[name] = name === 'ciudad' ? finalValue.toUpperCase() : finalValue;
        }

        setDestination(_destination);
    };

    const onInputNumberChange = (e, name) => {
        const val = e.value || 0;
        let _destination = { ...destination };
        _destination[`${name}`] = val;
        setDestination(_destination);
    };

    const onCheckboxChange = (e, name) => {
        let _destination = { ...destination };
        _destination[`${name}`] = e.checked;
        setDestination(_destination);
    };

    // Función para agregar marcador al hacer clic en el mapa
    const addMarker = (event) => {
        // Solo agregar marcador si no existe uno ya
        if (!destination.latitud || !destination.longitud) {
            const { lat, lng } = event.latlng;

            // Actualizar el estado del destino con las nuevas coordenadas
            setDestination({
                ...destination,
                latitud: lat,
                longitud: lng
            });
        }
    };

// Función para actualizar la posición cuando se mueve el marcador
    const updateMarkerPosition = {
        dragend: (event) => {
            const marker = event.target;
            const position = marker.getLatLng();

            // Actualizar el estado con la nueva posición
            setDestination({
                ...destination,
                latitud: position.lat,
                longitud: position.lng
            });
        }
    };

    // Función para mostrar el diálogo de confirmación
    const confirmDeleteDestination = (destination) => {
        confirmDialog({
            message: `¿Estás seguro de que deseas eliminar el destino ${destination.ciudad}?`,
            header: 'Confirmar Eliminación',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Sí',
            rejectLabel: 'No',
            accept: () => deleteDestination(destination),
            reject: () => {}
        });
    };

    // Función para eliminar el destino
    const deleteDestination = (destinationToDelete) => {
        let _destinations = destinations.filter(val => val.id !== destinationToDelete.id);
        disableDestination({id: destinationToDelete.id}).then(() => {
            setDestinations(_destinations);
            Swal.fire('Exitoso', 'Destino Eliminado', 'success');
        })
    };


    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button
                    label="Nuevo Destino"
                    icon="pi pi-plus"
                    className="mr-2"
                    severity="primary"
                    onClick={openNew}
                />
                <Button
                    label="Exportar"
                    icon="pi pi-upload"
                    className="p-button-help"
                    severity="secondary"
                    onClick={exportCSV}
                />
            </React.Fragment>
        );
    };

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <IconField iconPosition="right" className="mr-2">
                    <InputIcon className="pi pi-search" />
                    <InputText onChange={(e) => setGlobalFilter(e.target.value)}
                               placeholder="Buscar destinos..." />
                </IconField>
            </React.Fragment>
        );
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button
                    icon="pi pi-pencil"
                    className="p-button-rounded mr-2"
                    severity="primary"
                    onClick={() => editDestination(rowData)}
                />
                <Button
                    icon="pi pi-trash"
                    className="p-button-rounded"
                    severity="danger"
                    onClick={() => confirmDeleteDestination(rowData)}
                />
            </React.Fragment>
        );
    };

    const statusBodyTemplate = (rowData) => {
        return (
            <div className="status-badges">
                {rowData.activa && <span className="badge badge-active">Activa</span>}
                {rowData.foraneo && <span className="badge badge-foraneo">Foráneo</span>}
                {rowData.frecuente && <span className="badge badge-frecuente">Frecuente</span>}
            </div>
        );
    };

    const priceBodyTemplate = (rowData) => {
        return (
            <div className="price-info">
                <div><strong>Autobús:</strong> ${rowData.autobus?.toLocaleString()}</div>
                <div><strong>Camión:</strong> ${rowData.camion?.toLocaleString()}</div>
                <div><strong>Sprinter:</strong> ${rowData.sprinter?.toLocaleString()}</div>
                <div><strong>Van:</strong> ${rowData.van?.toLocaleString()}</div>
            </div>
        );
    };

    const destinationDialogFooter = (
        <React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label="Guardar" icon="pi pi-check" className="p-button-text" onClick={saveDestination} />
        </React.Fragment>
    );

    const deleteDestinationDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteDestinationDialog} />
            <Button label="Sí" icon="pi pi-check" className="p-button-text" onClick={deleteDestination} />
        </React.Fragment>
    );


    return (
        <div className="destination-catalog">
            <Toast ref={toast} />
            <ConfirmDialog />
            <Card className="catalog-card">
                <Toolbar className="mb-3" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>

                <DataTable
                    ref={dt}
                    value={destinations}
                    selection={selectedDestinations}
                    onSelectionChange={(e) => setSelectedDestinations(e.value)}
                    dataKey="id"
                    paginator
                    rows={10}
                    scrollable
                    scrollHeight="calc(100vh - 330px)"
                    rowsPerPageOptions={[5, 10, 25]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} destinos"
                    globalFilter={globalFilter}
                    header="Destinos Registrados"
                    responsiveLayout="scroll"
                    className="destinations-table"
                >
                    <Column field="id" header="ID" sortable style={{ minWidth: '4rem' }}></Column>
                    <Column field="ciudad" header="Ciudad" sortable style={{ minWidth: '12rem' }}></Column>
                    <Column field="estado" header="Estado" sortable style={{ minWidth: '10rem' }}></Column>
                    <Column field="kilometros" header="Kilómetros" sortable style={{ minWidth: '8rem' }}></Column>
                    <Column body={statusBodyTemplate} header="Estado" style={{ minWidth: '10rem' }}></Column>
                    <Column body={priceBodyTemplate} header="Precios" style={{ minWidth: '15rem' }}></Column>
                    <Column body={actionBodyTemplate} exportable={false} style={{ minWidth: '8rem' }}></Column>
                </DataTable>
            </Card>

            <Dialog
                visible={destinationDialog}
                style={{ width: '50vw', maxWidth: '1200px' }}
                header="Información del Destino"
                modal
                className="destination-dialog"
                footer={destinationDialogFooter}
                onHide={hideDialog}
            >
                <div className="destination-form">
                    <TabView>
                        <TabPanel header="Información General" leftIcon="pi pi-info-circle mr-2">
                            <div className="form-grid-destination">
                                <div className="form-group-destination">
                                    <label htmlFor="ciudad" className="form-label required">Ciudad</label>
                                    <InputText
                                        id="ciudad"
                                        value={destination.ciudad || ''}
                                        onChange={(e) => onInputChange(e, 'ciudad')}
                                        required
                                        className={submitted && !destination.ciudad ? 'p-invalid' : ''}
                                        placeholder="Nombre de la ciudad"
                                    />
                                    {submitted && !destination.ciudad && <small className="p-error">Ciudad es requerida.</small>}
                                </div>

                                <div className="form-group-destination">
                                    <label htmlFor="idEstado" className="form-label required">Estado</label>
                                    <Dropdown id="idEstado"
                                              name="idEstado"
                                              value={states.find(option => option.code === destination.idEstado)}
                                              options={states}
                                              onChange={(e) => onInputChange(e, 'idEstado')}
                                              optionLabel="name"
                                              placeholder="Nombre del estado"
                                              className={submitted && !destination.idEstado ? 'p-invalid' : ''}
                                    />
                                    {submitted && !destination.idEstado && <small className="p-error">Estado es requerido.</small>}
                                </div>

                                <div className="form-group-destination">
                                    <label htmlFor="kilometros" className="form-label">Kilómetros</label>
                                    <InputNumber
                                        id="kilometros"
                                        value={destination.kilometros}
                                        onValueChange={(e) => onInputNumberChange(e, 'kilometros')}
                                        placeholder="Distancia en km"
                                        className={submitted && !destination.kilometros ? 'p-invalid' : ''}

                                    />
                                    {submitted && !destination.kilometros && <small className="p-error">Kilometros es requerido.</small>}
                                </div>

                                <div className="form-group-destination">
                                    <label htmlFor="duracion" className="form-label">Horas de Viaje</label>
                                    <InputNumber
                                        id="duracion"
                                        value={destination.duracion}
                                        onValueChange={(e) => onInputNumberChange(e, 'duracion')}
                                    />
                                </div>

                                <div className="form-group-destination full-width">
                                    <label htmlFor="nota" className="form-label">Notas</label>
                                    <InputTextarea
                                        id="nota"
                                        value={destination.nota || ''}
                                        onChange={(e) => onInputChange(e, 'nota')}
                                        rows={3}
                                        placeholder="Notas adicionales sobre el destino"
                                    />
                                </div>

                                <div className="form-group-destination checkboxes">
                                    <div className="checkbox-item">
                                        <Checkbox
                                            inputId="activa"
                                            checked={destination.activa || false}
                                            onChange={(e) => onCheckboxChange(e, 'activa')}
                                        />
                                        <label htmlFor="activa" className="checkbox-label">Activa</label>
                                    </div>

                                    <div className="checkbox-item">
                                        <Checkbox
                                            inputId="foraneo"
                                            checked={destination.foraneo || false}
                                            onChange={(e) => onCheckboxChange(e, 'foraneo')}
                                        />
                                        <label htmlFor="foraneo" className="checkbox-label">Foráneo</label>
                                    </div>

                                    <div className="checkbox-item">
                                        <Checkbox
                                            inputId="frecuente"
                                            checked={destination.frecuente || false}
                                            onChange={(e) => onCheckboxChange(e, 'frecuente')}
                                        />
                                        <label htmlFor="frecuente" className="checkbox-label">Frecuente</label>
                                    </div>
                                </div>
                            </div>
                        </TabPanel>

                        <TabPanel header="Costos y Casetas" leftIcon="pi pi-dollar mr-2">
                            <div className="form-grid-destination">

                                <div className="form-group-destination">
                                    <label htmlFor="casetas2" className="form-label">Casetas 2 Ejes</label>
                                    <InputNumber
                                        id="casetas2"
                                        value={destination.casetas2}
                                        onValueChange={(e) => onInputNumberChange(e, 'casetas2')}
                                        mode="currency"
                                        currency="MXN"
                                        locale="es-MX"
                                    />
                                </div>

                                <div className="form-group-destination">
                                    <label htmlFor="casetas3" className="form-label">Casetas 3 Ejes</label>
                                    <InputNumber
                                        id="casetas3"
                                        value={destination.casetas3}
                                        onValueChange={(e) => onInputNumberChange(e, 'casetas3')}
                                        mode="currency"
                                        currency="MXN"
                                        locale="es-MX"
                                    />
                                </div>
                            </div>
                                <Divider />
                            <div className="form-grid-destination">
                                <div className="form-group-destination">
                                    <label htmlFor="autobus" className="form-label">Precio Autobús</label>
                                    <InputNumber
                                        id="autobus"
                                        value={destination.autobus}
                                        onValueChange={(e) => onInputNumberChange(e, 'autobus')}
                                        mode="currency"
                                        currency="MXN"
                                        locale="es-MX"
                                    />
                                </div>

                                <div className="form-group-destination">
                                    <label htmlFor="camion" className="form-label">Precio Camión</label>
                                    <InputNumber
                                        id="camion"
                                        value={destination.camion}
                                        onValueChange={(e) => onInputNumberChange(e, 'camion')}
                                        mode="currency"
                                        currency="MXN"
                                        locale="es-MX"
                                    />
                                </div>

                                <div className="form-group-destination">
                                    <label htmlFor="sprinter" className="form-label">Precio Sprinter</label>
                                    <InputNumber
                                        id="sprinter"
                                        value={destination.sprinter}
                                        onValueChange={(e) => onInputNumberChange(e, 'sprinter')}
                                        mode="currency"
                                        currency="MXN"
                                        locale="es-MX"
                                    />
                                </div>

                                <div className="form-group-destination">
                                    <label htmlFor="van" className="form-label">Precio Van</label>
                                    <InputNumber
                                        id="van"
                                        value={destination.van}
                                        onValueChange={(e) => onInputNumberChange(e, 'van')}
                                        mode="currency"
                                        currency="MXN"
                                        locale="es-MX"
                                    />
                                </div>
                            </div>

                        </TabPanel>

                        <TabPanel header="Ubicación" leftIcon="pi pi-map mr-2">

                            <div className="form-grid-destination">
                                <div className="form-group-destination">
                                    <label htmlFor="latitud" className="form-label">Latitud</label>
                                    <InputNumber
                                        id="latitud"
                                        value={destination.latitud}
                                        onValueChange={(e) => onInputNumberChange(e, 'latitud')}
                                        minFractionDigits={6}
                                        maxFractionDigits={6}
                                        placeholder="Coordenada de latitud"
                                        className={submitted && !destination.latitud ? 'p-invalid' : ''}

                                    />
                                    {submitted && !destination.latitud &&
                                        <small className="p-error">Latitud es requerido.</small>}

                                </div>

                                <div className="form-group-destination">
                                    <label htmlFor="longitud" className="form-label">Longitud</label>
                                    <InputNumber
                                        id="longitud"
                                        value={destination.longitud}
                                        onValueChange={(e) => onInputNumberChange(e, 'longitud')}
                                        minFractionDigits={6}
                                        maxFractionDigits={6}
                                        placeholder="Coordenada de longitud"
                                        className={submitted && !destination.longitud ? 'p-invalid' : ''}
                                    />
                                    {submitted && !destination.longitud &&
                                        <small className="p-error">Longitud es requerido.</small>}

                                </div>
                            </div>

                            <div className="location-info full-width" style={{marginTop: '2rem'}}>
                                <div className="info-card">
                                    <i className="location-tooltip pi pi-info-circle"
                                       style={{fontSize: '1.5rem', cursor: 'pointer', color: '#0b7ad1'}}
                                    ></i>
                                    <Tooltip target=".location-tooltip" style={{fontSize: '.75rem'}}>
                                        <h4>Información de Ubicación</h4>
                                        <p>Las coordenadas de latitud y longitud se utilizan para mostrar la ubicación
                                            exacta del destino en el mapa y calcular rutas precisas.</p>
                                    </Tooltip>
                                </div>
                                {/* Buscador de direcciones */}
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        marginBottom: '1rem'
                                    }}
                                >
                                    <div style={{ width: '250px' }}>
                                        <INEGIGeocoderInput
                                            placeholder="Buscar dirección..."
                                            onLocationSelect={location => setDestination({
                                                ...destination,
                                                latitud: location.lat,
                                                longitud: location.lng
                                            })}
                                        />
                                    </div>
                                </div>

                                <div className="info-card">
                                    <Map
                                        center={DEFAULT_CENTER}
                                        zoom={10}
                                        scrollWheelZoom={true}
                                        style={{ width: '100%', height: '20rem', zIndex: "0" }}
                                        onClick={addMarker}
                                    >

                                        {/* Marcador y vuelo al destino */}
                                        {(destination.latitud && destination.longitud) && (
                                            <>
                                                <DestinationMarker
                                                    draggable={true}
                                                    position={[destination.latitud, destination.longitud]}
                                                    eventHandlers={updateMarkerPosition}
                                                    markerRef={markerRef}
                                                />
                                                <MapFlyToProveedor
                                                    lat={destination.latitud}
                                                    lng={destination.longitud}
                                                />
                                            </>
                                        )}
                                    </Map>
                                </div>

                            </div>
                        </TabPanel>
                    </TabView>
                </div>
            </Dialog>
        </div>
    );
};

export default DestinationCatalog;